import { PushNotifications } from '@capacitor/push-notifications';
import { isNative } from './platform';
import MaperNative from './maperNative';
import { routeForNotification } from './notificationRoute';
import { recordNotificationEngagement } from './notificationEngagement';

export const initPushNotifications = (history: { push: (path: string) => void }) => {
    if (!isNative()) return;

    const listeners: Promise<{ remove: () => Promise<void> }>[] = [];

    listeners.push(
        PushNotifications.addListener('registration', () => {
            // Same reasoning as the registrationError handler below: this is the call that
            // repairs a fresh install, where the native side declined to register the token
            // for lack of credentials. An `UNIMPLEMENTED` here means the MaperNative plugin
            // never reached the bridge, and swallowing it hides that behind a silent device.
            MaperNative.registerPendingFcmToken().catch((error) => {
                // eslint-disable-next-line no-console
                console.error('[push] could not register the FCM token with the backend:', error);
            });
        }),
    );

    listeners.push(
        PushNotifications.addListener('registrationError', (error) => {
            // NEVER swallow this. Registration failing is the single most likely reason
            // "push doesn't work", and its causes are all build/permission configuration
            // rather than anything visible at runtime — on iOS the classic one is a
            // missing `aps-environment` entitlement (the Push Notifications capability
            // not enabled on the target), which fails here and nowhere else. Discarding
            // it turns a five-minute configuration fix into a hunt through the backend.
            // eslint-disable-next-line no-console
            console.error('[push] APNs/FCM registration failed — no pushes will arrive on this device:', error);
        }),
    );

    listeners.push(PushNotifications.addListener('pushNotificationReceived', () => {}));

    listeners.push(
        PushNotifications.addListener('pushNotificationActionPerformed', (action) => {
            const data = action.notification.data;
            // Fire and forget, and deliberately BEFORE routing: the analytics write must
            // never delay the navigation, and routing proceeds whether or not it lands.
            recordNotificationEngagement(data);
            const route = routeForNotification(data);
            if (route) {
                history.push(route);
            }
        }),
    );

    PushNotifications.requestPermissions().then((permission) => {
        if (permission.receive === 'granted') {
            PushNotifications.register();
        }
    });

    return () => {
        listeners.forEach((l) => l.then((h) => h.remove()));
    };
};
